import { Environment } from '@abp/ng.core';

const baseUrl = 'https://zendra-planning-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://zendra-infra-auth-server-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'Planning',
  responseType: 'code',
  scope: 'offline_access openid profile email phone AuthServer IdentityService AdministrationService AuditLoggingService SaasService LanguageService Geographic Operational Orchestrator Inventory Controlling General Planning WoodSecurity WoodSupply Projection',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  production: false,
  application: {
    baseUrl,
    name: 'Planning',
  }, 
  localization: {
    defaultResourceName: 'LanguageService'
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://zendra-infra-webgateway-dev.upmuruguay.net',
      rootNamespace: 'Upm.Zendra.Planning',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
    Geographic: {
      url: 'https://zendra-planning-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.Planning.Geographic',
    },
    Inventory: {
      url: 'https://zendra-planning-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.Planning.Inventory',
    },
    Operational: {
      url: 'https://zendra-planning-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.Planning.Operational',
    },
    General: {
      url: 'https://zendra-cbd-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.General',
    },
    Controlling: {
      url: 'https://zendra-cbd-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.Controlling',
    },
    Planning: {
      url: 'https://zendra-cbd-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.Planning',
    },
    WoodSupply: {
      url: 'https://zendra-cbd-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.WoodSupply',
    },
    WoodSecurity: {
      url: 'https://zendra-cbd-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.WoodSecurity',
    },
    Orchestrator: {
      url: 'https://zendra-planning-webgateway-dev.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.Planning.Orchestrator',
    },
    AdministrationService: {
      url: 'https://zendra-infra-webgateway-dev.upmuruguay.net',
      rootNamespace: 'Upm.Zendra.AdministrationService',
    },
  },
  newRelicFrontend: {
    isEnabled: false,
  }
} as Environment;
